var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { findDOMNode } from 'react-dom';
import cs from '../_util/classNames';
import { Enter } from '../_util/keycode';
import autoSizeTextAreaHeight from './autoSizeTextAreaHeight';
import omit from '../_util/omit';
import { ConfigConsumer } from '../ConfigProvider';
var TextArea = /** @class */ (function (_super) {
    __extends(TextArea, _super);
    function TextArea(props) {
        var _this = _super.call(this, props) || this;
        _this.currentRows = 1;
        // 应对中文输入问题
        _this.isComposition = false;
        _this.resizeTextAreaHeight = function () {
            var textAreaStyle = autoSizeTextAreaHeight(_this.props.autoSize, findDOMNode(_this.textareaRef));
            if (textAreaStyle) {
                _this.setState({ textAreaStyle: textAreaStyle });
            }
        };
        _this.focus = function () {
            _this.textareaRef && _this.textareaRef.focus && _this.textareaRef.focus();
        };
        _this.blur = function () {
            _this.textareaRef && _this.textareaRef.blur && _this.textareaRef.blur();
        };
        _this.handleChange = function (e) {
            var maxLength = _this.props.maxLength;
            var newValue = e.currentTarget.value;
            _this.resizeTextAreaHeight();
            if (!_this.isComposition) {
                if (maxLength) {
                    if (newValue.length <= maxLength) {
                        _this.setValue(newValue);
                    }
                }
                else {
                    _this.setValue(newValue);
                }
            }
            else {
                _this.setState({
                    compositionValue: newValue,
                });
            }
        };
        _this.setValue = function (value) {
            var onChange = _this.props.onChange;
            if (!('value' in _this.props)) {
                _this.setState({
                    value: value,
                });
            }
            onChange && onChange(value);
        };
        _this.onKeyDown = function (e) {
            var _a = _this.props, onKeyDown = _a.onKeyDown, onPressEnter = _a.onPressEnter;
            var keyCode = e.keyCode || e.which;
            onKeyDown && onKeyDown(e);
            if (keyCode === Enter.code) {
                onPressEnter && onPressEnter(e);
            }
        };
        // 处理中文输入
        _this.onComposition = function (e) {
            if (e.type === 'compositionend') {
                _this.isComposition = false;
                _this.setState({
                    compositionValue: undefined,
                    value: e.target.value,
                });
                _this.setValue(e.target.value);
            }
            else {
                _this.isComposition = true;
            }
        };
        _this.renderTextArea = function (_a) {
            var getPrefixCls = _a.getPrefixCls;
            var _b = _this.props, className = _b.className, style = _b.style, wrapperStyle = _b.wrapperStyle, placeholder = _b.placeholder, disabled = _b.disabled, error = _b.error, maxLength = _b.maxLength, showWordLimit = _b.showWordLimit, rest = __rest(_b, ["className", "style", "wrapperStyle", "placeholder", "disabled", "error", "maxLength", "showWordLimit"]);
            var _c = _this.state, textAreaStyle = _c.textAreaStyle, value = _c.value, compositionValue = _c.compositionValue;
            var prefixCls = getPrefixCls('textarea');
            var classNames = cs(prefixCls, className, {
                error: error,
            });
            var otherProps = omit(rest, [
                'autoSize',
                'allowClear',
                'defaultValue',
                'onPressEnter',
            ]);
            if (disabled) {
                textAreaStyle.resize = 'none';
            }
            var TextAreaElement = (React.createElement("textarea", __assign({}, otherProps, { ref: function (ref) { return (_this.textareaRef = ref); }, style: __assign(__assign({}, style), textAreaStyle), className: classNames, placeholder: placeholder, disabled: disabled, onChange: _this.handleChange, onKeyDown: _this.onKeyDown, onCompositionStart: _this.onComposition, onCompositionUpdate: _this.onComposition, onCompositionEnd: _this.onComposition, maxLength: maxLength, value: compositionValue || value || '' })));
            var valueLength = value ? value.length : 0;
            return maxLength && showWordLimit ? (React.createElement("div", { className: prefixCls + "-wrapper", style: wrapperStyle },
                TextAreaElement,
                React.createElement("span", { className: prefixCls + "-word-limit" },
                    valueLength,
                    "/",
                    maxLength))) : (TextAreaElement);
        };
        _this.state = {
            textAreaStyle: {},
            value: props.value || props.defaultValue || '',
        };
        return _this;
    }
    TextArea.getDerivedStateFromProps = function (nextProps) {
        if ('value' in nextProps) {
            // 如果配置了 `maxLength`, 需要对值进行截断
            return {
                value: nextProps.maxLength && nextProps.value
                    ? nextProps.value.slice(0, nextProps.maxLength)
                    : nextProps.value || '',
            };
        }
        return null;
    };
    TextArea.prototype.componentDidMount = function () {
        this.resizeTextAreaHeight();
    };
    TextArea.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.value !== this.props.value) {
            this.resizeTextAreaHeight();
        }
    };
    TextArea.prototype.render = function () {
        return React.createElement(ConfigConsumer, null, this.renderTextArea);
    };
    TextArea.propTypes = {
        className: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
        disabled: PropTypes.bool,
        error: PropTypes.bool,
        autoSize: PropTypes.oneOfType([
            PropTypes.bool,
            PropTypes.shape({
                minRows: PropTypes.number,
                maxRows: PropTypes.number,
            }),
        ]),
        onChange: PropTypes.func,
        placeholder: PropTypes.string,
        style: PropTypes.object,
        wrapperStyle: PropTypes.object,
        defaultValue: PropTypes.string,
        onPressEnter: PropTypes.func,
        maxLength: PropTypes.number,
        showWordLimit: PropTypes.bool,
    };
    TextArea.defaultProps = {
        autoSize: false,
    };
    return TextArea;
}(PureComponent));
export default TextArea;
